import { Routes, Route } from 'react-router-dom';
import { Radio, LayoutDashboard } from 'lucide-react';
import { SubmitPage } from '@/pages/SubmitPage';
import { StatusPage } from '@/pages/StatusPage';
import { ResultsPage } from '@/pages/ResultsPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { LabOSTopbar } from './lib/labos';

const logo = (
  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <img src="/cnn-logo.svg" alt="CNN" style={{ height: '22px' }} />
    <span style={{ color: 'rgba(128,128,128,0.4)', fontWeight: 300 }}>|</span>
    <Radio style={{ width: '18px', height: '18px' }} />
  </span>
);

const navLinks = [
  {
    to: '/dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboard style={{ width: '15px', height: '15px' }} />,
  },
];

function App() {
  return (
    <div className="min-h-screen bg-background">
      <LabOSTopbar logo={logo} appName="Podcast News Analyzer" appSubtitle="(Non-Production PoC)" navLinks={navLinks} />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<SubmitPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/jobs/:jobId" element={<StatusPage />} />
        <Route path="/jobs/:jobId/results" element={<ResultsPage />} />
      </Routes>
    </div>
  );
}

export default App;
